module.exports = __webpack_public_path__ + "img/sacco11.cf6d5f2c.png";